<main id="main-content" tabindex="-1" aria-label="Course">
    @if (!isEdit && !startCourse) {
        <div class="content-contain mx-auto my-4">
            <prism-title additionalClasses="text-4xl text-center sm:text-left" [title]="course?.name"></prism-title>
                @if (isAdmin) {
                    <div>
                        <prism-btn btnClass="btn-white" (click)="toggleEdit()">
                            <i class="uil uil-edit text-lg"></i>
                            <span class="text-lg"> Edit Course</span>
                        </prism-btn>
                    </div>
                }
            <hr class="h-1 bg-dark-purple border-0 my-4">

            <prism-title additionalClasses="text-xl pt-3" title="Attachments" headingLevel="h2"></prism-title>
            <div class="grid grid-cols-1 lg:grid-cols-4 gap-4">
               
                @if (user.userId) {
                    <div class="col-span-1 gap-1 flex flex-wrap flex-col md:flex-row pb-4">
                        <prism-btn [disabled]="!hasCertificate" btnClass="btn-purple flex-full w-full text-nowrap" (click)="viewPrintCertificate()">Download Certificate
                            <i class="uil uil-import text-xl text-white"></i>
                        </prism-btn>
                    </div>
                }
            </div>
            <prism-title additionalClasses="text-xl pt-3" title="Course Description" headingLevel="h2"></prism-title>
            <p>
                {{ course?.description}}
            </p>
            @if (user.userId) {
                <prism-btn [disabled]="isDataLoading" btnClass="mt-4 btn-purple flex-full pt-2 text-nowrap" (click)="toggleStartCourse()">
                    {{ btnText }}
                </prism-btn>
            }
        </div>
    } @else if (isEdit) {
        <prism-course-edit
            [course]="course"
            [attachments]="attachments"
            (isEditChange)="updateCourse()"
            (updateCourseAttachments)="updateAttachments()">
        </prism-course-edit>
    } @else if (startCourse) {
        <div class="my-5 content-contain">
            <prism-course-view [courseName]="courseName" [courseId]="courseId" (allSectionsComplete)="handleAllComplete($event)"
                (courseCompleted)="handleCourseCompleted($event)">
            </prism-course-view>
            <div class="mt-5">
                <prism-btn (click)="openDigitalNotebook()">PRISM Digital Notebook Entry</prism-btn>
            </div>
            <div *ngIf="!hasCertificate && !(userCourse?.isCompleted || !isCourseCompleted)">
                <div class="flex flex-nowrap justify-center items-center my-5" [formGroup]="completeForm">
                    <label for="acknowledge" class="cursor-pointer border-2 border-dark-purple p-2 mt-5 block">
                        <input type="checkbox" id="acknowledge" [checked]="userCourse?.isCompleted"
                            (change)="handleCheckbox()" />
                        By submitting your reflections, you acknowledge that they are intended solely for your professional
                        growth and
                        development. Your responses will remain private.
                        <br>
                        <br>
                        <span>
                            <span class="red-asterisk">*</span>
                            You must remain in the course for at least {{ courseTimeoutMinutes }} minutes,
                            complete the course, and digital notebook to enable the Agree and Submit button and checkbox.
                        </span>
                    </label>
                </div>
                <div class="flex flex-nowrap justify-center items-center mb-5">
                    <prism-btn [disabled]="isSubmitting" btnClass="btn-purple flex-fit pt-2 w-48 text-nowrap mb-5" (keydown)="!isSubmitting && handleKeydown($event)"
                        (click)="!isSubmitting && submit()">Agree and Submit</prism-btn>
                </div>
            </div>
        </div>
    }
</main>
<ng-template #startCourseContent>
  <p class="modal-title"><strong>Please Note: To receive credit for this course you must:</strong></p>
  <ul class="bullet-points">
    <li>Remain in the course for at least 60 minutes</li>
    <li>Complete each module</li>
    <li>Complete the digital notebook for each module</li>
    <li>Click the Agree and Submit button</li>
  </ul>
</ng-template>